'use strict';
var RebindStrategy;
(function (RebindStrategy) {
    RebindStrategy["Impression"] = "impression";
    RebindStrategy["Click"] = "click";
    RebindStrategy["Abandon"] = "abandon";
})(RebindStrategy || (RebindStrategy = {}));
export default RebindStrategy;
